import { TopNavigation } from '@amzn/awsui-components-react';
import { Auth } from 'aws-amplify';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { ROUTE_PATH } from './common/constants/route_paths';

const TopNavBar = () => {
  const [userAlias, setUserAlias] = useState('Account');

  useEffect(() => {
    let mounted = true;
    Auth.currentSession()
      .then(session => {
        if (!mounted) return;
        const attributes = get(session.getIdToken(), 'payload', {});
        const alias =
          get(attributes, ['identities', 0, 'userId']) ||
          get(attributes, 'cognito:username') ||
          get(attributes, 'email', 'Account');
        setUserAlias(alias === 'Account' ? alias : `${alias}@`);
      })
      .catch(() => {});

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div style={{ position: 'sticky', top: 0, zIndex: 1100 }}>
      <TopNavigation
        identity={{
          href: ROUTE_PATH.ORBIT_PAGE,
          title: 'Orbit',
          logo: {
            src: `${process.env.PUBLIC_URL}/amazon-logo.svg`,
            alt: 'Amazon',
          },
        }}
        utilities={[
          {
            type: 'menu-dropdown',
            iconName: 'user-profile-active',
            text: userAlias,
            items: [{ id: 'signout', text: 'Sign out' }],
            onItemClick: ({ detail }) => {
              if (detail.id === 'signout') Auth.signOut();
            },
          },
        ]}
      />
    </div>
  );
};

export default TopNavBar;
